export default {
  init() {
    const init = this,
        menuButton = $('.menu-button'),
        siteBody = $('body'),
        siteNav = $('.side-nav'),
        calendarSection = $('.calendar-section'),
        loginButton = $('.membership-button'),
        loginModal = $('.login-form-modal'),
        searchButton = $('header .search-icon'),
        searchModal = $('.search-form-modal'),
        searchToggles = $('.search-section .btn'),
        searchMemberType = $('input[name="member_type"]'),
        linkBoxesSection = $('.link-boxes-section'),
        frontLinkBoxesSection = $('.front-link-boxes-section'),
        resourceCategories = $('.resource-categories'),
        accordionBoxes = $('.accordion-section > div'),
        popupModal = $('.modal-background'),
        advertorialSlider = $('.advertorial-slider'),
        CVButton = $('.cv-button'),
        trainingBox = $('.training-box'),
        signUpForm = $('#mc-embedded-subscribe-form');

    menuButton.on('click', function () {
      if( menuButton.hasClass('is--toggled') ) {
        var windowScroll = $('body').css('top').replace(/[^-\d\.]/g, '')  * -1;
        menuButton.removeClass('is--toggled');
        siteNav.removeClass('is--visible');
        siteBody.removeClass('locked');
        siteBody.css('position', '');
        siteBody.css('top', '');
        $(document).scrollTop(windowScroll);
      } else {
        var windowScroll = $(document).scrollTop();
        menuButton.addClass('is--toggled');
        siteNav.addClass('is--visible');
        siteBody.addClass('locked');
        siteBody.css('position', 'fixed');
        siteBody.css('top', '-' + windowScroll + 'px');
      }
    });

    searchToggles.on('click', function () {
      $('.search-section .btn.is--active').removeClass('is--active');
      var memberType = $(this).attr('data-search-type');
      searchMemberType.val(memberType);
      $(this).addClass('is--active');
    });

    loginButton.on('click', function () {
      loginModal.toggleClass('is--toggled');
    })

    searchButton.on('click', function () {
      searchModal.toggleClass('is--toggled');
    })

    CVButton.on('click', function (e) {
      e.preventDefault();
      var memberNum = $(this).attr('data-mem-num'),
          CVUrl = $(this).attr('href'),
      ajaxArgs = {
        url: TAE_CONFIG.ajaxurl,
        type: 'POST',
        nonce: TAE_CONFIG.nonce,
        data: {
          action: 'tae_cv_counter',
          member_num: memberNum
        }
      };

      $.ajax(ajaxArgs).done( function(ret) {
        window.location.href = CVUrl;
      });
    });

    if( calendarSection.length ) {
      this.calendarFunctions();
    }

    if( advertorialSlider.length ) {
      var sliderSettings = {
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        dots: false,
        arrows: false,
        infinite: true,
      };

      advertorialSlider.slick(sliderSettings);
    }

    if( accordionBoxes.length ) {
      accordionBoxes.each(function () {
        $(this).find('input').on('click', function () {
          $(this).parent('.faq').toggleClass('is--active');
        });
      });
    }

    if( popupModal.length ) {
      if( !this.getCookie('tae_email_popup') ) {
        var parentApp = this;
        popupModal.addClass('is--visible');

        popupModal.find('.close-button').on('click', function () {
          popupModal.removeClass('is--visible');
          parentApp.setCookie('tae_email_popup', 'popuphidden', 30);
        });

        signUpForm.on('submit', function () {
          popupModal.removeClass('is--visible');
          parentApp.setCookie('tae_email_popup', 'popuphidden', 30);
        });
      }
    }

    if( trainingBox.length ) {
      var events = $('.event-container');
      events.each(function() {
        var eventContent = $(this).find('.event-content'),
            contentHeight = eventContent.outerHeight(),
            eventImage = $(this).find('.event-featured-image img');

        eventImage.css('height', contentHeight / 2);
      });
    }
  },
  finalize() {
    const linkBoxesSection = $('.link-boxes-section'),
          frontLinkBoxesSection = $('.front-link-boxes-section'),
          resourceCategories = $('.resource-categories'),
          membershipDashboard = $('.membership-dashboard');

    if( linkBoxesSection.length ) {
      this.equalizer(linkBoxesSection, '.post-block');
    }

    if( frontLinkBoxesSection.length ) {
      this.equalizer(frontLinkBoxesSection, '.btn');
    }

    if( resourceCategories.length ) {
      this.equalizer(resourceCategories, '.post-block');
    }
  },
  calendarFunctions() {
    const navBtns = $('.calendar-navigation-month'),
          calendar = $('.calendar'),
          d = new Date(),
          n = ('0' + (d.getMonth() + 1)).toString().slice(-2),
          y = d.getFullYear().toString(),
          currentMonth = y + n,
          nextMonthButton = $('.next-month'),
          prevMonthButton = $('.prev-month'),
          events = $('.event-container');

    calendar.scrollTo('#' + currentMonth);

    navBtns.on('click', function () {
      var calendarMonth = $(this).attr('data-month');
      calendar.scrollTo('#' + calendarMonth);
    });

    nextMonthButton.on('click', function () {
      var monthWidth = $('.calendar-month').width(),
          currentScroll = calendar.scrollLeft();
      calendar.scrollLeft(currentScroll + monthWidth);
    });
    prevMonthButton.on('click', function () {
      var monthWidth = $('.calendar-month').width(),
          currentScroll = calendar.scrollLeft();
      calendar.scrollLeft(currentScroll - monthWidth);
    });

    events.each(function() {
      var eventContent = $(this).find('.event-content'),
          contentHeight = eventContent.outerHeight(),
          eventImage = $(this).find('.event-featured-image img');

      eventImage.css('height', contentHeight);
    });
  },
  equalizer(parent, child) {
    parent.each(function () {
      var children = parent.find(child),
          colHeight = 0;

      children.each(function () {
        var childHeight = $(this).height();

        if( childHeight > colHeight ) {
          colHeight = childHeight;
        }
      });

      children.height(colHeight);
    });
  },
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },
  setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
}
